import React from "react";
import { string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TopArrowContainer from "../TopArrowContainer";
import VersionList from "../VersionList";
import { staticTexts } from "../../utils/Translate";

import "./dropdown.m.css";

const Dropdown = ({ label, publisherAttributes }) => {
  const value = staticTexts(publisherAttributes.lang).language;

  return (
    <ul styleName={`wrapper ${publisherAttributes.lang === "en" ? "en-wrapper" : ""}`}>
      <div styleName="edition-label">
        <label styleName="label">{label}</label>
        <span styleName="current-value">{value}</span>
        <i styleName="down" />
        <i styleName="up" />
      </div>
      <div styleName="top-arrow-container-wrapper">
        <TopArrowContainer className="top-arrow-container">
          <VersionList />
        </TopArrowContainer>
      </div>
    </ul>
  );
};

Dropdown.propTypes = {
  label: string,
  publisherAttributes: object
};

const mapStateToProps = state => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

export default connect(mapStateToProps, null)(Dropdown);
